import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { PatrolDiscordCockpitService } from '../../../services/patrol-discord-cockpit.service';

@Component({
  selector: 'app-patrol-discord-activity',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './patrol-discord-activity.component.html',
  styleUrl: './patrol-discord-activity.component.scss',
})
export class PatrolDiscordActivityComponent {
  #cockpit = inject(PatrolDiscordCockpitService);

  readonly activityStats = this.#cockpit.activityStats;
  readonly recentCases = this.#cockpit.recentCases;
  readonly isLoading = this.#cockpit.isLoadingActivity;
  readonly loadError = this.#cockpit.activityError;

  formatDate(iso: string): string {
    return this.#cockpit.formatDate(iso);
  }

  actionLabel(action: string): string {
    const key = `app.patrol.discord.cockpit.activity.actions.${action}`;
    return key;
  }

  openCase(caseId: string): void {
    this.#cockpit.openCaseRecord(caseId);
  }
}
